var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stu-tutorial',{on:{"seeDetails":function($event){_vm.lookOverDetail($event)},"back":_vm.goBack}})}
var staticRenderFns = []

export { render, staticRenderFns }